import { API_END_POINTS_MODELS } from "../Models/ApiEndPointModels";

const API_END_POINTS: API_END_POINTS_MODELS = {
  LOGIN: "get_feature_link",
  VERIFY_MAGIC_LINK: "featured_verify_link",
  MODELS_LIST: "embedding_model_list",
  WEBLINK_MODEL: 'weblink_collect',
  UPLOAD_MODEL: "upload_file/",
  VIEWPORT_DATA: "viewport_data",
  FEATURE_STATUS: "feature_status_link",
  VIEWPORT_DATA_DRAFT: "viewport_draft_data",
  VIEWPORT_DRAFT_MODELS_LIST: "viewport_draft_model_list",
  VIEWPORT_GENERATED_MODELS_LIST: "viewport_model_list",
  VIEWPORT_VIEW_DRAFT_MODEL: "embedding_model_details",
  DASHBOARD_GENERAL_SEARCH: "general_search",
  DELETE_MODEL_LIST: "embedding_model_delete/",
  ADMIN_PROFILE: "admin_profile",
  FILE_UPLOAD: "file_upload/",
  GET_ADMIN_PROFILE: "admin_deatils/",
  CREATE_CONNECTION: "connection/create_connection",
  GET_CHAT_REDIRECT_LINK: "chat_redirect",
  GET_NODES_DATA: "get_nodes",
  GET_EDGES_DATA: "get_edges",
  VIEW_PORT_MODEL_LIST: "link_model_lists",
  CONTEX_MODEL: "viewport_context",
  CHAT_HISTORY: "chat_history/",
  STAFF_LIST: "staff_list/",
  GET_PRIVILAGE_LIST: "privilage_list/",
  ONBOARD_STAFFS: "onboard_staffs",
  UPDATE_STAFFS_PRIVILEGE: "update_privilage",
  ONBOARD_SINGLE_STAFF: "onboard_staffs",
  GET_WORKBENCH_PERMISION: "get_workbench_permissions/",
  STAFF_SHARE_MODELS: "staff_share_models",
  UPDATE_USER_PERMISSION: "update_user_permission",
  WORKBENCH_PERMISTION_LIST: "workbench_permission_list/",
  UPDATE_COLOR_GRADIENT: "colour_gradient",
  GET_COLOR_GRADIENT: "get_colour_gradient/",
  STAFF_EMAIL_LIST: "staff_emails",
  // Add other endpoints here

  SEMANTIC_CONNECTION_CREATE: "/create_connection",
  QUERY_SCHEMA: "/query_schemas",
  QUERY_WORKBENTCH: "/query_workbench",
  CONNECTION_LIST: "/connection_lists/",
  MAKE_QUERIES: "/make_queries",
  GET_QUERIES: "/get_queries",
  GET_SEMANTIC_GENERATE: "/get_query_results",
  GET_MODEL_LIST: "/query_models/",
  CONNECTION_DATA: "/connection_data",
  SAVE_PAGEBUILDER: "/report/save_pagebuilder",
  GET_PAGEBUILDER_DATA: "report/get_pagebuilder",
  FEATURE_STATUS_LINK: "/feature_status_link",
  CREATE_PAGEBUILDER: "report/create_pagebuilder",
  EMBEDDING_MODEL_DELETE: "embedding_model_delete/",
  DELETE_JOIN: "query/delete_join/",
  GET_WORKBENCH_MODEL_DATA: "/sample_data",
  GENERATE_SEMANTIC_QUERIES: "/generate_queries",
  DRAFT_EMBEDDING_MODELS: "/draft_query_models/",
  CONNECTION_DELETE: "/connection_delete",
  RENAME_QUERYTAB: "/query/rename_joined_data",
  EMBED_MODEL_RESULT_EXPORT: "/export"
};

export default API_END_POINTS;
